export function formatBusinessName (str) {
    try {
        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()

        // remove accents, swap ñ for n, etc
        const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
        const to = 'aaaaeeeeiiiioooouuuunc------'
        for (let i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str
            .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '') // collapse whitespace for now
            .replace(/-+/g, '') // remove dashes for now

        return str
    } catch (err) {
        return ''
    }
}

// one-way data binding

class BoundNode {
    constructor(node) {
        this.node = node
    }

    update(data) {
        this.node.value = data.businessNameValue
    }
}

class BoundModel {
    constructor(handlers) {
        const callbacks = []
        const data = {
            addCallback: function addCallback(fn) {
                callbacks.push(fn)
            },
        }

        const proxy = new Proxy(data, {
            set: function (target, property, value) {
                target[property] = value
                callbacks.forEach((callback) => callback())
                return true
            },
        })

        return proxy
    }
}

// EVR-9726
// When user enters Business Name, pre-populate 
function updateWorkspaceURLbasedOnBusinessName() {
    const businessNameInput = document.getElementById('business_name')
    const vanityURLEl = document.getElementById('vanity_url');

    if (businessNameInput && vanityURLEl) {
        const vanityURLInput = new BoundNode(document.querySelector('#vanity_url'))
        const syncModel = new BoundModel()
    
        syncModel.addCallback(() => {
            vanityURLInput.update(syncModel)
        })
    
        businessNameInput.addEventListener('keyup', function (e) {
            syncModel.businessNameValue = formatBusinessName(e.currentTarget.value)
        })
    }
}

// EVR-9727 - when user checks "I'm individual" checkbox on Setup Your Business
// pre-populate Workspace URL with concatenated First- and Lastname
function updateWorkspaceURLbasedOnFirstLastNames() {
    const individualCheckbox = document.getElementById('individual');
    const firstNameInputEl = document.getElementById('signup-first-name-input');
    const lastNameInputEl = document.getElementById('signup-last-name-input');
    const vanityURLEl = document.getElementById('vanity_url');

    if (individualCheckbox && firstNameInputEl && lastNameInputEl && vanityURLEl) {
        individualCheckbox.addEventListener('change', function(e) {
            const isChecked = e.target.checked;
            const firstLastName = firstNameInputEl.value + lastNameInputEl.value
            
            if (isChecked) {
                vanityURLEl.value = formatBusinessName(firstLastName);
            }
        })
    }
}

export function newBusinessSelect() {
    updateWorkspaceURLbasedOnBusinessName();
    updateWorkspaceURLbasedOnFirstLastNames();
}
